import React from 'react';
import { ShieldCheckIcon, TerminalIcon } from 'lucide-react';
export function CTASection() {
  return <section id="checkout" className="py-14 relative overflow-hidden" data-id="element-36">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-37"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-38">
        <div className="text-center mb-8" data-id="element-39">
          <TerminalIcon className="w-12 h-12 text-cyan-400 mx-auto mb-4" data-id="element-40" />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-41">
            Enter The New Elite
          </h2>
          <p className="text-xl text-gray-300 mb-5" data-id="element-42">
            As an Architect of the $10k Engine, you no longer trade your health
            for a paycheck. You no longer worry about "AI taking your job"
            because you are the one pulling the levers of the machine.
          </p>
          <p className="text-2xl font-bold text-cyan-400 text-glow mb-8" data-id="element-43">
            Stop prompting. Start building the machine that prompts for you.
          </p>
        </div>

        <div className="bg-dark-900 border-2 border-cyan-500/50 rounded-2xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(0,240,255,0.1)] relative overflow-hidden" data-id="element-44">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 to-blue-600" data-id="element-45"></div>

          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-46">
            THE $10K AI CONTENT ENGINE
          </h3>
          <p className="text-gray-400 mb-8" data-id="element-47">
            (Includes The Full 30-Day Execution Sprint Plan)
          </p>

          <div className="text-5xl font-bold text-white mb-8 flex items-center justify-center gap-2" data-id="element-48">
            <span className="text-2xl text-gray-500 font-normal line-through" data-id="element-49">
              $47
            </span>
            $6.36{' '}
            <span className="text-lg text-gray-500 font-normal" data-id="element-50">
              One-Time Payment
            </span>
          </div>

          <a href="https://coresolutionsg.com/cart/47508774125755:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'The $10K AI Content Engine',
              content_type: 'product',
              value: 6.36,
              currency: 'USD'
            });
          }
        }} className="w-full group relative inline-flex items-center justify-center px-8 py-5 font-bold text-black bg-cyan-400 rounded-sm overflow-hidden transition-all hover:bg-cyan-300 hover:shadow-[0_0_30px_rgba(0,240,255,0.5)] mb-6" data-id="element-51">
            <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-full group-hover:h-56 opacity-10" data-id="element-52"></span>
            <span className="relative text-lg tracking-wide uppercase" data-id="element-53">
              Get Instant Access Now
            </span>
          </a>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-54">
            <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-55" />
            <span data-id="element-56">Secure Checkout • Instant Delivery</span>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cyan-900/30" data-id="element-57">
          <p className="text-lg text-gray-300 mb-8" data-id="element-58">
            Welcome to the Ghost in the Machine.
            <br data-id="element-59" />
            <br data-id="element-60" />
            To your success,
            <br data-id="element-61" />
            <strong className="text-white text-[16px] font-[400]" data-id="element-62">
              The $10K AI Content Engine.
            </strong>
          </p>

          <div className="bg-dark-950 p-6 rounded-lg border border-cyan-900/20 text-gray-400 text-sm leading-relaxed" data-id="element-63">
            <strong className="text-cyan-400" data-id="element-64">P.S.</strong> In the US market,
            time is more valuable than money. High-ticket clients will pay you
            $2,500/month just to stop thinking about content. I'm showing you
            how to be the person they pay. Don't get left behind in the manual
            labor era. Enter the Architecture era today.
          </div>
        </div>
      </div>
    </section>;
}